// i18n area 'auth' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.sk-SK.meta.json.
import type { enUS } from './auth'

export const skSK: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Prihláste sa do svojho účtu',
    username: 'Používateľské meno',
    usernamePlaceholder: 'Zadajte používateľské meno',
    usernameHint: 'Použite používateľ@doména na prihlásenie voči adresárovému realmu',
    continue: 'Pokračovať',
    changeUser: 'Nie ste to vy?',
    password: 'Heslo',
    forgotPassword: 'Zabudli ste heslo?',
    submit: 'Prihlásiť sa',
    otp: 'Jednorazový kód',
    otpSubtitle: 'Zadajte kód zo svojho autentifikátora',
    otpHint: 'Šesť číslic z autentifikačnej aplikácie alebo jeden z kódov na obnovenie',
    otpSubmit: 'Overiť',
    invalidCredentials: 'Neplatné používateľské meno alebo heslo',
    tooManyAttempts: 'Priveľa pokusov — chvíľu počkajte a skúste to znova',
    realmUnavailable: 'Realm teraz nemôže overiť poverenia — store klastra je nedostupný. Prihláste sa ako lokálny používateľ (break-glass).',
    genericError: 'Prihlásenie zlyhalo — je backend TVirt dostupný?'
  },
  user: {
    logout: 'Odhlásiť sa',
    password: {
      menu: 'Zmeniť heslo',
      title: 'Zmena hesla',
      current: 'Aktuálne heslo',
      new: 'Nové heslo',
      confirm: 'Potvrďte nové heslo',
      mismatch: 'Heslá sa nezhodujú',
      error: 'Heslo sa nepodarilo zmeniť',
      forcedTitle: 'Na pokračovanie si zmeňte heslo',
      forcedHint: 'Toto heslo nastavil správca a pred vstupom ho treba nahradiť.',
      forcedSubmit: 'Zmeniť a vstúpiť'
    },
    mfa: {
      title: 'Dvojfaktorové overovanie',
      subtitle: 'Druhý faktor vyžadovaný pri každom prihlásení',
      loadError: 'Nepodarilo sa načítať stav druhého faktora',
      enrolled: 'Aktívny',
      notEnrolled: 'Neaktívny',
      enrolledAt: 'Aktivovaný dňa',
      codesRemaining: 'Zostávajúce kódy na obnovenie',
      requiredHint:
        'Správca vyžaduje na tomto účte druhý faktor: nastavte si ho teraz — kým to neurobíte, môžete sa prihlásiť, ale takmer nič iné.',
      enroll: 'Nastaviť',
      enrollTitle: 'Nastavenie dvojfaktorového overovania',
      enrollHint: 'Naskenujte tento kód autentifikačnou aplikáciou a potom na potvrdenie zadajte kód, ktorý zobrazí.',
      secretHint: 'Nedá sa naskenovať? Zadajte do aplikácie tento tajný kľúč:',
      code: 'Kód z aplikácie',
      confirm: 'Potvrdiť',
      startError: 'Nastavenie sa nepodarilo spustiť',
      confirmError: 'Nastavenie sa nepodarilo potvrdiť',
      codesTitle: 'Vaše kódy na obnovenie',
      codesWarning:
        'Tieto kódy sa zobrazujú len raz. Uložte si ich teraz: každý z nich vás prihlási, keď je autentifikátor nedostupný, a platí len raz.',
      codesAck: 'Uložil(a) som si kódy na obnovenie',
      codesDone: 'Hotovo',
      copy: 'Kopírovať',
      copied: 'Skopírované',
      download: 'Stiahnuť',
      regenerate: 'Nové kódy na obnovenie',
      regenerateTitle: 'Znova vygenerovať kódy na obnovenie',
      regenerateHint: 'Všetky doteraz vydané kódy prestanú fungovať v okamihu, keď sa vygeneruje nová sada.',
      regenerateConfirm: 'Znova vygenerovať',
      regenerateError: 'Kódy na obnovenie sa nepodarilo znova vygenerovať',
      remove: 'Odobrať',
      removeTitle: 'Odobrať druhý faktor',
      removeConfirm: 'Odobrať',
      removeHint: 'Účet sa vráti k samotnému heslu. Druhý faktor si môžete kedykoľvek nastaviť znova.',
      removeRequiredHint:
        'Správca vyžaduje na tomto účte druhý faktor, takže server jeho odobratie odmietne — najprv ho požiadajte o zrušenie tejto povinnosti.',
      removeError: 'Druhý faktor sa nepodarilo odobrať'
    },
    profile: {
      menu: 'Prejsť na môj profil',
      sessions: 'Aktívne relácie',
      sessionsHint: 'Vaše otvorené relácie na tomto uzle',
      sessionsEmpty: 'Žiadne aktívne relácie',
      sessionCreated: 'Prihlásenie',
      sessionExpires: 'Vyprší',
      revoke: 'Odvolať reláciu',
      revokeError: 'Reláciu sa nepodarilo odvolať',
      loadError: 'Relácie sa nepodarilo načítať'
    }
  }
}
